import { useMemo } from 'react'
import useAxios from 'axios-hooks'
import { DEFAULT_PAGINATION_SIZE } from 'utils/constants'

const NAMESPACE = 'scholarships-stage'
const DEFAULT_PARAMS = {
  page: 1,
  pageSize: DEFAULT_PAGINATION_SIZE,
  orderColumn: 'programName',
  orderDirection: 'ASC',
  showDifferences: true,
}

export const useGetAll = (params) => {
  const [
    { data, loading, error },
    reFetch,
  ] = useAxios({
    url: NAMESPACE,
    params: { ...DEFAULT_PARAMS, ...params },
  })

  return useMemo(() => ({
    data,
    loading,
    error,
    reFetch,
  }), [
    data,
    loading,
    error,
    reFetch,
  ])
}
